import { useRef, useEffect } from 'react';

/*
 * This hook is used to restore focus to the element
 * that was focused before the component was mounted.
 */

const useRestoreFocus = () => {
    const activeElement = typeof window !== 'undefined' && window.document.activeElement;
    const activeElementOnMount = useRef(activeElement).current;

    useEffect(() => () => activeElementOnMount && activeElementOnMount.focus(), []);
};

export default useRestoreFocus;
